<header>
    <!-- Top Navbar  -->
    <div class="top-menubar">
      <div class="topmenu">
        <div class="container">
          <div class="row">
            <div class="col-md-7">
              <ul class="list-inline top-contacts">
                <li>
                  <i class="fa fa-envelope"></i> Email:
                  <a href="mailto:admin@mundofinanciera.com"
                    >admin@mundofinanciera.com</a
                  >
                </li>
                <li> Líneas directas:    Operaciones <i class="fa fa-whatsapp"></i><a href="https://wa.me/3164034791?text=Operaciones">3164034791</a> - Recaudo y Cartera <i class="fa fa-whatsapp"></i><a href="https://wa.me/3174409708?text=Recaudo y Cartera">3174409708</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Navbar -->
    <nav
      class="navbar navbar-expand-lg navbar-light"
      id="mainNav"
      data-toggle="affix"
    >
      <div class="container">
        <a class="navbar-brand smooth-scroll" routerLink="/home">
          <img src="assets/img/logo-s.png" alt="logo" />
        </a>
        <button
          class="navbar-toggler navbar-toggler-right"
          type="button"
          data-toggle="collapse"
          data-target="#navbarResponsive"
          aria-controls="navbarResponsive"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarResponsive">
          <ul class="navbar-nav ml-auto">
            <li class="nav-item">
              <a class="nav-link smooth-scroll" routerLink="/home">Inicio</a>
            </li>
            <li class="nav-item dropdown">
              <a
                class="nav-link smooth-scroll"
                routerLink="/quienessomos"
                id="navbarDropdownMenuLink"
                aria-haspopup="true"
                aria-expanded="false"
                >Quienes somos</a
              >
              <!--<div class="dropdown-menu dropdown-cust" aria-labelledby="navbarDropdownMenuLink">
                  <a class="dropdown-item" href="about.html">About Us</a>
                  <a class="dropdown-item" href="careers.html">Career Oprtunity</a>
                  <a class="dropdown-item" href="team.html">Meet Our Team</a>
                  <a class="dropdown-item" href="faq.html">FAQ</a>
                  <a class="dropdown-item" href="testimonials.html">Testimonials</a>
                </div>-->
            </li>
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle smooth-scroll"
                href="#"
                id="navbarDropdownMenuLink"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                href="services.html"
                >Nuestros Aliados</a
              >
              <div
                class="dropdown-menu dropdown-cust"
                aria-labelledby="navbarDropdownMenuLink"
              >
                <a class="dropdown-item" routerLink="/merquellantas"
                  >Merquellantas</a
                >
                <a class="dropdown-item" routerLink="/remaxPage">Remax</a>
                <!--<a class="dropdown-item" [routerLink]="['user']">Usuarios</a>-->
              </div>
            </li>

            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle smooth-scroll"
                id="navbarDropdownMenuLink"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                >Servicios y soluciones</a
              >
              <div
                class="dropdown-menu dropdown-cust"
                aria-labelledby="navbarDropdownMenuLink"
              >
                <a class="dropdown-item" routerLink="/pague-aqui"
                  >Pague Aquí</a
                >
                <a class="dropdown-item" routerLink="/firma-electronica"
                  >Firma electrónica de su crédito</a
                >
                <a class="dropdown-item" routerLink="/merquellantas"
                  >Solicitudes de Crédito</a
                >
                <a class="dropdown-item" routerLink="/punto-pago"
                  >Puntos de Pago</a
                >
              </div>
            </li>
            <li class="nav-item">
              <a class="nav-link smooth-scroll" routerLink="/contacto"
                >Contáctenos</a
              >
              <div
                class="dropdown-menu dropdown-cust"
                aria-labelledby="navbarDropdownMenuLink"
              >
                <!--<a class="dropdown-item" href="news-list.html">News list layouts</a>
                  <a class="dropdown-item" href="news-grid.html">News grid layouts</a>
                  <a class="dropdown-item" href="news-details.html">News Details</a>
                  <a class="dropdown-item" href="project.html">Project</a>
                  <a class="dropdown-item" href="contact.html">Contact Us</a>
                  <a class="dropdown-item" href="comming-soon.html">Comming Soon</a>
                  <a class="dropdown-item" href="pricing.html">Pricing Tables</a>
                  <a class="dropdown-item" href="admin/404.html">404</a>-->
              </div>
            </li>
            <!--<<li class="nav-item dropdown" >
                <a class="nav-link dropdown-toggle smooth-scroll" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Shop</a>
                <div class="dropdown-menu dropdown-cust mega-menu" aria-labelledby="navbarDropdownMenuLink">
                  <div class="row">
                    <div class="col-md-5">
                      <a class="dropdown-item" href="shop.html">Shop Detail</a>
                      <a class="dropdown-item" href="single-product.html">Single Product</a>
                      <a class="dropdown-item" href="cart.html">Cart</a>
                      <a class="dropdown-item" href="checkout.html">Checkout</a>
                      <a class="dropdown-item" href="myaccount.html">Myaccount</a>
                    </div>
                    <div class="col-md-7 mega-menu-img m-auto text-center pl-0">
                      <a href="#"><img src="img/offer_icon.png" alt="" class="img-fluid"></a>
                    </div>
                  </div>
                </div>
              </li>-->
            <li>
              <div class="top-menubar-nav">
                <div class="topmenu">
                  <div class="container">
                    <div class="row">
                      <div class="col-md-9">
                        <ul class="list-inline top-contacts">
                          <li>
                            <i class="fa fa-envelope"></i> Email:
                            <a href="hola@mundofinanciera.com"
                              >hola@mundofinanciera.com</a
                            >
                          </li>
                          <li>
                            <i class="fa fa-phone"></i> (7) 123 4567 89
                          </li>
                        </ul>
                      </div>
                      <div class="col-md-3">
                        <ul class="list-inline top-data">
                          <li>
                            <a href="#" target="_empty"
                              ><i class="fa top-social fa-facebook"></i
                            ></a>
                          </li>
                          <li>
                            <a href="#" target="_empty"
                              ><i class="fa top-social fa-twitter"></i
                            ></a>
                          </li>
                          <li>
                            <a href="#" target="_empty"
                              ><i class="fa top-social fa-google-plus"></i
                            ></a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </header>
